import { compose } from 'redux';
import { connect } from 'react-redux';
import CountdownView from '../../../common/countdown/countdownView';
import { goToPassage } from '../../../common/navigation/navigationActions';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';
import withBlockedBackNavigation from '../../../common/utils/withBlockedBackNavigation';
import { getAvatarPosition } from '../../../common/alex/AlexUtils';

const avatarMapStateToProps = () => {
    const positionConfig = {
        alyxPosition: AvatarView.Position.TOP_HEADER_CENTER,
        defaultViewPosition: AvatarView.Position.LOWER_LEFT,
    };
    const position = getAvatarPosition(positionConfig);
    return {
        position,
        animateAlex: true,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onEndCounting: () => {
        dispatch(goToPassage(ownProps.flowStrategy.assessment));
    },
});

const MazeCountdownContainer = compose(
    connect(null, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(withBlockedBackNavigation(CountdownView));

export default MazeCountdownContainer;
